import { render, staticRenderFns } from "./RefreshPassword.vue?vue&type=template&id=b059b182&scoped=true&"
import script from "./RefreshPassword.vue?vue&type=script&lang=js&"
export * from "./RefreshPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b059b182",
  null
  
)

export default component.exports